import React from 'react';
import { FormattedDate } from 'react-intl';

import { Button, Currency, Icon } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { RETURN_CODE_UNSUBMITTED, VALUE_NA } from '../../shop/constants';

export default [
  {
    header: <TranslatedCopy id='returnStatus.authNumber' />,
    id: 'returnAuthorization',
    cell: returnItem => returnItem.returnAuthorization || VALUE_NA
  },
  {
    header: <TranslatedCopy id='global.department' />,
    id: 'departmentName',
    cell: returnItem => returnItem.departmentName || VALUE_NA
  },
  {
    header: <TranslatedCopy id='returnStatus.returnReference' />,
    id: 'returnReference'
  },
  {
    header: <TranslatedCopy id='returnStatus.creditType' />,
    id: 'creditType',
    cell: returnItem => (
      <TranslatedCopy id={`returnStatus.creditType.${returnItem.creditType.split('-').join('.').toLowerCase()}`} />
    )
  },
  {
    header: <TranslatedCopy id='orderreturns.returnAmount' />,
    id: 'creditAmount',
    cell: returnItem =>
      returnItem.creditAmount ? <Currency value={returnItem.creditAmount} type={returnItem.currencyCode} /> : VALUE_NA
  },
  {
    header: <TranslatedCopy id='global.submittedBy' />,
    id: 'submittedBy',
    cell: returnItem => returnItem.submittedBy || VALUE_NA
  },
  {
    header: <TranslatedCopy id='orderstatus.orderSubmittedDate' />,
    id: 'dateSubmitted',
    cell: returnItem =>
      returnItem.dateSubmitted ? <FormattedDate value={returnItem.dateSubmitted} timeZone='utc' /> : VALUE_NA
  },
  {
    header: <TranslatedCopy id='returnStatus.dateExpires' />,
    id: 'dateExpired',
    cell: returnItem => returnItem.dateExpired && <FormattedDate value={returnItem.dateExpired} timeZone='utc' />
  },
  {
    header: (returnItem, { handleStatusDetailsClick }) => (
      <div>
        <TranslatedCopy id='returnStatus.title' />
        <> </>
        <Button className='returnStatus__tooltip' onClick={handleStatusDetailsClick}>
          <Icon name='filled-question' />
        </Button>
      </div>
    ),
    id: 'returnStatus',
    cell: returnItem =>
      returnItem.returnStatus &&
      new TranslatedCopy({
        id: `returnStatus.returnStatus.${returnItem.returnStatus.split(' ').join('').toLowerCase()}`
      }).toString()
  },
  {
    header: returnItem => (returnItem.returnStatus === RETURN_CODE_UNSUBMITTED ? '' : null),
    id: null,
    cell: (returnItem, { handleDeleteClick }) => {
      const deleteText = new TranslatedCopy({ id: 'returnStatus.delete' }).toString();
      return returnItem.returnStatus === RETURN_CODE_UNSUBMITTED ? (
        <button
          type='button'
          className='returnStatus__tooltip'
          onClick={e => handleDeleteClick(returnItem.returnId, e)}
          title={deleteText}
          aria-label={deleteText}
        >
          <Icon name='trash' />
        </button>
      ) : null;
    }
  }
];
